export const tr = {
    'relevance-match': 'otomatik hedefleme'
};
